import { render, staticRenderFns } from "./TabPresidentes.vue?vue&type=template&id=5eebe5d5"
import script from "./TabPresidentes.vue?vue&type=script&lang=ts"
export * from "./TabPresidentes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports